import axios from "axios";
import app_config from "app_config";
import { Staff } from "@custom-types/Staff";
import {SchoolInfo} from "@custom-types/SchoolInfo";

const APIURL = app_config.APIURLBase + "admin/login";


export interface ALoginAPIPostRequest {
  idkind: string;
  loginid: string;
  password: string;
  siteName: string;
  debugMode: number;
}

export interface ALoginAPIGetResponse {
  schoolInfo: SchoolInfo;
  userInfo: {
    staff: Staff;
  };
}

export interface ALoginAPIPostResponse {
  session: string;
  schoolInfo: SchoolInfo;
  userInfo: {
    staff: Staff;
  };
}



/**
 * ALoginAPI
 */
class ALoginAPI {
  /**
   * get
   * @param siteName 施設名
   * @param session セッション情報
   * @param signal 操作を中止するためのAbortSignal
   * @return 成功時はALoginAPIGetResultオブジェクトが返る。失敗時はaxios Errorオブジェクトが返る。
   */
  static async get(siteName: string, session: string, signal?: AbortSignal): Promise<ALoginAPIGetResponse> {
    const res = await axios.post(APIURL,
      {
        method: "get",
        siteName: siteName,
      },
      {
        signal: signal,
        headers: {
          "Authorization": session
        }
      }
    );
    
    return res.data;
  }


  /**
   * post
   * @param data 送信データ
   * @param signal 操作を中止するためのAbortSignal
   * @return data
   */
  static async post(data: ALoginAPIPostRequest, signal?: AbortSignal): Promise<ALoginAPIPostResponse> {
    const res = await axios.post<ALoginAPIPostResponse>(APIURL,
      {
        method: "post",
        siteName: data.siteName,
        idkind: data.idkind,
        loginid: data.loginid,
        password: data.password,
        debugMode: data.debugMode,
      },
      {
        signal: signal,
      }
    );
    
    return res.data;
  }
}


export {
  ALoginAPI as default,
  ALoginAPI,
};
